import { BikeType } from "./bike-type.enum";
import { BikeState } from "./bike-state.enum";
import { Lock } from "./lock";
import { Geopoint } from "./geopoint";
import { Group } from "./group";
import { AttachmentPoint } from "./attachmentpoint";

export class Bike {
    id : number;
    creationDate : Date;
    lastCommunicationDate : Date;
    name : string;
    type : string;
    state : string;
    location : Geopoint;

    groupId : number;
    groupName : string;
    attachmentPointId : number;
    lockId : string;
    lockType : string;

    stationId : string;
    stationName : string;    
}



// WEBPACK FOOTER //
// ./src/app/models/bike.ts